import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ActivityLogItemContanier = styled(Column)`
  border-radius: 4px;
  padding: 10px;
  margin: 10px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.hoverBrand};
  }
`;
